import { ApiClient, ApiPaginationResult } from '~/apiclient/apiclient'
import { Collection, DisplayCollection } from '~/models/collection'

export async function getCollection(
  this: ApiClient,
  collectionSlug: string,
  lite?: boolean
): Promise<Collection | DisplayCollection> {
  const { data } = await this.$axios.get(`node/collections/${collectionSlug}`, {
    params: {
      lite,
    },
  })
  return data
}

export async function getCollectionByHashtag(
  this: ApiClient,
  hashtag: string
): Promise<ApiPaginationResult<DisplayCollection>> {
  const { data } = await this.$axios.get(`node/collections/hashtag/${hashtag}`)
  return data
}

export async function getMenuCollections(
  this: ApiClient
): Promise<ApiPaginationResult<DisplayCollection>> {
  const { data } = await this.$axios.get(`node/collections?menu=true`)
  return data
}

export enum BroadcasterCollectionType {
  Group = 'group',
  State = 'state',
  Country = 'country',
  Local = 'local',
  Vacant = 'vacant',
}

export interface BroadcasterCollectionApi {
  broadcasterCollectionID: number
  title: string
  description: string | null
  imageURL: string | null
  notes: string | null
  type: BroadcasterCollectionType
  value: string | null
  latitude: number | null
  longitude: number | null
  zoomFactor: string | null
}

export async function getBroadcasterCollection(
  this: ApiClient,
  type: BroadcasterCollectionType,
  value?: string
): Promise<BroadcasterCollectionApi> {
  const { data } = await this.$axios.get('node/collections/broadcasters', {
    params: {
      type,
      value,
    },
  })
  return data
}
